import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { FaDownload, FaGamepad } from 'react-icons/fa6';

import { BTN_GLOW_SM } from '@/constants/button-classes';

import { Kicker } from '../download/kicker';

export function ServersFinalCta() {
  const { t } = useTranslation('pages/servers', { keyPrefix: 'v2.finalCta' });

  return (
    <section aria-labelledby='servers-cta-heading' className='relative mx-auto w-full max-w-[1400px] p-5 xl:pb-20 xl:pt-10'>
      <div className='relative overflow-hidden rounded-[18px] border border-[rgba(156,255,46,0.22)] bg-[rgba(11,15,18,0.72)] p-2.5 shadow-[0_0_0_1px_rgba(156,255,46,0.09),0_34px_100px_-58px_var(--green-glow)] backdrop-blur-xl sm:p-5'>
        <div className='pointer-events-none absolute inset-x-0 top-0 h-px bg-[linear-gradient(90deg,transparent,rgba(156,255,46,0.72),transparent)]' aria-hidden='true' />
        <div className='pointer-events-none absolute inset-0 bg-[linear-gradient(120deg,rgba(156,255,46,0.12),transparent_34%),linear-gradient(180deg,rgba(255,255,255,0.035),transparent_55%)]' aria-hidden='true' />
        <div className='relative flex flex-col gap-5'>
          <Kicker icon={FaGamepad}>{t('eyebrow')}</Kicker>
          <h2 id='servers-cta-heading' className='font-display text-[clamp(36px,4.6vw,68px)] font-black leading-[0.94] text-[var(--fg)]'>
            {t('title')}
          </h2>
          <p className='text-base leading-[1.7] text-[var(--fg-dim)]'>{t('copy')}</p>
          <Link href={t('href')} className={`${BTN_GLOW_SM} w-full sm:w-fit`}>
            <FaDownload size={13} aria-hidden='true' />
            {t('cta')}
          </Link>
        </div>
      </div>
    </section>
  );
}
